import { ReportData } from '../types/reportTypes';

// November 2025 Sales Data - Standard Report (24 jobs from CSV)
const jobData = [
  {
    jobInfo: "Cynthia Adams",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 6472.00,
    grossMarginPct: 0.4002,
    grossProfit: 2590.09,
    commissionPercentage: 4.00,
    salesCommission: 258.88,
    salesManagerFee: 64.72,
    companyOH: 1003.16,
    netProfit: 0
  },
  {
    jobInfo: "Ann Jeffries",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 14656.00,
    grossMarginPct: 0.4000,
    grossProfit: 5862.40,
    commissionPercentage: 4.00,
    salesCommission: 586.24,
    salesManagerFee: 146.56,
    companyOH: 2271.68,
    netProfit: 0
  },
  {
    jobInfo: "Julia Andretta",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 10972.00,
    grossMarginPct: 0.4000,
    grossProfit: 4388.80,
    commissionPercentage: 4.00,
    salesCommission: 438.88,
    salesManagerFee: 109.72,
    companyOH: 1700.66,
    netProfit: 0
  },
  {
    jobInfo: "Anne & Richard Zaworski",
    leadSource: "Porch",
    trade: "Windows & Doors",
    contractTotal: 4953.00,
    grossMarginPct: 0.4000,
    grossProfit: 1981.20,
    commissionPercentage: 4.00,
    salesCommission: 198.12,
    salesManagerFee: 49.53,
    companyOH: 767.72,
    netProfit: 0
  },
  {
    jobInfo: "Dylan & Ruth Duhaime",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 5870.00,
    grossMarginPct: 0.6475,
    grossProfit: 3800.83,
    commissionPercentage: 10.00,
    salesCommission: 587.00,
    salesManagerFee: 58.70,
    companyOH: 909.85,
    netProfit: 0
  },
  {
    jobInfo: "Joey & Dawn Fox",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 3892.00,
    grossMarginPct: 0.4000,
    grossProfit: 1556.80,
    commissionPercentage: 4.00,
    salesCommission: 155.68,
    salesManagerFee: 38.92,
    companyOH: 603.26,
    netProfit: 0
  },
  {
    jobInfo: "Treva & DARWIN Pitts",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 23621.00,
    grossMarginPct: 0.4505,
    grossProfit: 10641.26,
    commissionPercentage: 4.00,
    salesCommission: 944.84,
    salesManagerFee: 236.21,
    companyOH: 3661.26,
    netProfit: 0
  },
  {
    jobInfo: "John & Laura Richard Crino",
    leadSource: "Google Organic Search",
    trade: "Siding Replacement/Windows & Doors",
    contractTotal: 39321.00,
    grossMarginPct: 0.4215,
    grossProfit: 16573.80,
    commissionPercentage: 4.00,
    salesCommission: 1572.84,
    salesManagerFee: 393.21,
    companyOH: 6094.76,
    netProfit: 0
  },
  {
    jobInfo: "Natalie & Sean Carr",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 9472.00,
    grossMarginPct: 0.4649,
    grossProfit: 4403.53,
    commissionPercentage: 4.00,
    salesCommission: 378.88,
    salesManagerFee: 94.72,
    companyOH: 1468.16,
    netProfit: 0
  },
  {
    jobInfo: "E-693: Anahy & Kevin Hector Garcia Lavato",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 3972.00,
    grossMarginPct: 0.6385,
    grossProfit: 2536.12,
    commissionPercentage: 10.00,
    salesCommission: 397.20,
    salesManagerFee: 39.72,
    companyOH: 615.66,
    netProfit: 0
  },
  {
    jobInfo: "E-692: Clay & Margaret Uhing",
    leadSource: "RoofHero",
    trade: "Attic Insulation/Roofing",
    contractTotal: 27270.00,
    grossMarginPct: 0.5338,
    grossProfit: 14556.73,
    commissionPercentage: 7.00,
    salesCommission: 1908.90,
    salesManagerFee: 272.70,
    companyOH: 4226.85,
    netProfit: 0
  },
  {
    jobInfo: "Christen & Danny Stevenson",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 2475.00,
    grossMarginPct: 0.5088,
    grossProfit: 1259.28,
    commissionPercentage: 7.00,
    salesCommission: 173.25,
    salesManagerFee: 24.75,
    companyOH: 383.63,
    netProfit: 0
  },
  {
    jobInfo: "Kevin Banks",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 7678.00,
    grossMarginPct: 0.4404,
    grossProfit: 3381.39,
    commissionPercentage: 4.00,
    salesCommission: 307.12,
    salesManagerFee: 76.78,
    companyOH: 1190.09,
    netProfit: 0
  },
  {
    jobInfo: "Jessica & Jared Anderson",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 9816.00,
    grossMarginPct: 0.4000,
    grossProfit: 3926.40,
    commissionPercentage: 4.00,
    salesCommission: 392.64,
    salesManagerFee: 98.16,
    companyOH: 1521.48,
    netProfit: 0
  },
  {
    jobInfo: "Juan & Maria Estrada Sanchez",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 23000.00,
    grossMarginPct: 0.3971,
    grossProfit: 9133.30,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 230.00,
    companyOH: 3565.00,
    netProfit: 0
  },
  {
    jobInfo: "Richard Delinsky",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 3392.00,
    grossMarginPct: 1.0000,
    grossProfit: 3392.00,
    commissionPercentage: 10.00,
    salesCommission: 339.20,
    salesManagerFee: 33.92,
    companyOH: 525.76,
    netProfit: 0
  },
  {
    jobInfo: "E-722: Katherine & Jens Herberholz",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 5621.00,
    grossMarginPct: 0.5566,
    grossProfit: 3128.65,
    commissionPercentage: 7.00,
    salesCommission: 393.47,
    salesManagerFee: 56.21,
    companyOH: 871.26,
    netProfit: 0
  },
  {
    jobInfo: "E-720: Abe Washington",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 4492.00,
    grossMarginPct: 0.5915,
    grossProfit: 2657.02,
    commissionPercentage: 7.00,
    salesCommission: 314.44,
    salesManagerFee: 44.92,
    companyOH: 696.26,
    netProfit: 0
  },
  {
    jobInfo: "E-701: Larry & Elizabeth Smith",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 3972.00,
    grossMarginPct: 0.7402,
    grossProfit: 2940.07,
    commissionPercentage: 10.00,
    salesCommission: 397.20,
    salesManagerFee: 39.72,
    companyOH: 615.66,
    netProfit: 0
  },
  {
    jobInfo: "E-723: Warren Bell",
    leadSource: "eLocal",
    trade: "Roofing",
    contractTotal: 37500.00,
    grossMarginPct: 0.4429,
    grossProfit: 16608.75,
    commissionPercentage: 4.00,
    salesCommission: 1500.00,
    salesManagerFee: 375.00,
    companyOH: 5812.50,
    netProfit: 0
  },
  {
    jobInfo: "E-727: Freddie Afshar",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Windows & Doors",
    contractTotal: 24400.00,
    grossMarginPct: 0.3489,
    grossProfit: 8513.16,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 244.00,
    companyOH: 3782.00,
    netProfit: 0
  },
  {
    jobInfo: "E-696: WASIM & Shaista MIRZA",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 7712.14,
    grossMarginPct: 0.4135,
    grossProfit: 3188.97,
    commissionPercentage: 4.00,
    salesCommission: 308.49,
    salesManagerFee: 77.12,
    companyOH: 1195.38,
    netProfit: 0
  },
  {
    jobInfo: "E-724: John & joanna Smith",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 4500.00,
    grossMarginPct: 0.4502,
    grossProfit: 2025.90,
    commissionPercentage: 4.00,
    salesCommission: 180.00,
    salesManagerFee: 45.00,
    companyOH: 697.50,
    netProfit: 0
  },
  {
    jobInfo: "E-707: Jeffrey Hayden",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Siding - Vinyl",
    contractTotal: 500.00,
    grossMarginPct: 0.2059,
    grossProfit: 102.95,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 5.00,
    companyOH: 77.50,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from CSV
const adSpendData = [
  { source: "Networx", spend: 1473.00 },
  { source: "Thumbtack", spend: 7195.96 },
  { source: "Yelp", spend: 12914.42 },
  { source: "Porch", spend: 643.89 },
  { source: "Web to Lead Form", spend: 3350.00 },
  { source: "Angi", spend: 2366.00 },
  { source: "Homebuddy", spend: 560.00 },
  { source: "RoofHero", spend: 2100.00 },
  { source: "Google Organic Search", spend: 7000.00 },
  { source: "Google Paid Search", spend: 6630.00 },
  { source: "Facebook / Meta Ads", spend: 469.40 },
  { source: "BBB", spend: 300.00 },
  { source: "Modernize", spend: 900.00 },
  { source: "33 Mile Radius / Everconnect", spend: 6214.00 },
  { source: "eLocal", spend: 0.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const novemberData: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 11, // November
    year: 2025
  }
};
